import { render, staticRenderFns } from "./systemBulletin.vue?vue&type=template&id=268efe77"
import script from "./systemBulletin.vue?vue&type=script&lang=js"
export * from "./systemBulletin.vue?vue&type=script&lang=js"
import style0 from "./systemBulletin.vue?vue&type=style&index=0&id=268efe77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports